'use strict';

var pull = require('pull-stream');

var lp = require('pull-length-prefixed');

var lpOpts = {
  fixed: true,
  bytes: 4
};

exports.createBoxStream = function (cipher, mac) {
  return pull(ensureBuffer(), pull.asyncMap(function (chunk, cb) {
    cipher.encrypt(chunk, function (err, data) {
      if (err) {
        return cb(err);
      }

      mac.digest(data, function (err, digest) {
        if (err) {
          return cb(err);
        }

        cb(null, Buffer.concat([data, digest]));
      });
    });
  }), lp.encode(lpOpts));
};

exports.createUnboxStream = function (decipher, mac) {
  return pull(ensureBuffer(), lp.decode(lpOpts), pull.asyncMap(function (chunk, cb) {
    var l = chunk.length;
    var macSize = mac.length;

    if (l < macSize) {
      return cb(new Error("buffer (".concat(l, ") shorter than MAC size (").concat(macSize, ")")));
    }

    var mark = l - macSize;
    var data = chunk.slice(0, mark);
    var macd = chunk.slice(mark);
    mac.digest(data, function (err, expected) {
      if (err) {
        return cb(err);
      }

      if (!macd.equals(expected)) {
        return cb(new Error("MAC Invalid: ".concat(macd.toString('hex'), " != ").concat(expected.toString('hex'))));
      } // all good, decrypt


      decipher.decrypt(data, function (err, decrypted) {
        if (err) {
          return cb(err);
        }

        cb(null, decrypted);
      });
    });
  }));
};

function ensureBuffer() {
  return pull.map(function (c) {
    if (typeof c === 'string') {
      return Buffer.from(c, 'utf-8');
    }

    return c;
  });
}